<div class="action-row-align" innerHTML="{{ explanationText | translate: lang }}"></div>
